// import React from "react";
// import { BrowserRouter } from "react-router-dom";
// import Navbar from "./Component/Navbar/Navbar";

// function App() {
//   return (
//     <BrowserRouter>
//       <Navbar />
//     </BrowserRouter>
//   );
// }

// export default App;




import React from "react";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Navbar from "./Component/Navbar/Navbar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Component/CustomToast/CustomToast.css";
import DownloadProgressToast from "./Component/CustomToast/DownloadProgressToast";
import NetworkStatusModal from "./Component/NetworkStatus/NetworkStatusModal";

import Service from "./Service";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes cache
      gcTime: 30 * 60 * 1000,    // keep in cache for 30 minutes
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Service />
        <ToastContainer
          position="top-right"
          autoClose={3500}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          style={{ zIndex: 99999999 }}
        />
        <DownloadProgressToast />
        <NetworkStatusModal />
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;

